appSocial.component('portfolioList', {
    templateUrl: 'widgets/portfolio/components/portfolio-list/PortfolioListComponent.html',
    bindings: {
    },
    controller: class PortfolioListComponent {
        constructor(
            $state,
            SocialTypes,
            SocialLocaleService,
            SocialFavoriteService,
            SocialPortfolioService,
            SocialUserService,
            SocialUtils) {

            /**
             * @type {SocialFavoriteService}
             */
            this.favoriteService = SocialFavoriteService;
            /**
             * @type {SocialPortfolioService}
             */
            this.portfolioService = SocialPortfolioService;
            /**
             * @type {SocialUserService}
             */
            this.userService = SocialUserService;

            this.utils = SocialUtils;

            this.translation = SocialLocaleService.translation;

            this.summary = {
                initial: 0,
                current: 0,
                pnl: 0
            };

            this.traders = this.portfolioService.getAll();
            this.lastTraderId = $state.params.id;

            this.user = this.userService.get();
        }

        $onInit() {
            this.updateSummary();
        }

        $onChanges(changes) {

        }

        $onDestroy() {
            console.log('on destroy')
        }

        updateSummary() {
            this.summary = {
                initial: this.traders.reduce((acc, cur) => acc + cur.followDeposit, 0),
                current: this.traders.reduce((acc, cur) => acc + cur.followBalance, 0),
                pnl: this.traders.reduce((acc, cur) => acc + cur.followPnlPercents, 0)
            };
        }

        setFavorites(traders) {
            traders.forEach(trader => trader && (trader.isFavorite = this.favoriteService.isFavorite(trader.id)));
        }

    }
});
